function bps4__enableCalls() {
    $('.bps4-off').addClass('D(n)');
    $('.bps4-on').removeClass('D(n)');

    $('.bps4-on').each(function (k, v) {

        if ($(v).get(0).hasAttribute('data-bps4-on-href')) {
            $(v).attr('href', $(v).attr('data-bps4-on-href'));
        }
        if ($(v).get(0).hasAttribute('data-bps4-on-onclick')) {
            $(v).attr('onclick', $(v).attr('data-bps4-on-onclick') ? $(v).attr('data-bps4-on-onclick') : '');
        }
    });
}

function bps4__setUserInterface(user) {

    if (getEnv() != 'prod') {
        console.log('setUserInterface', user);
    }

    if (user["status"] != "FAIL") {

        jQuery(".notlogged").addClass('D(n)!');
        jQuery(".logged").removeClass('D(n)!');
        var username = "";
        if (typeof user["profile"] != "undefined") {
            if (typeof user["profile"]["firstName"] != "undefined") {
                username = user["profile"]["firstName"];
                if (typeof user["profile"]["lastName"] != "undefined") {
                    username = username + " "
                        + user["profile"]["lastName"];
                }
            } else {
                if (typeof user["profile"]["lastName"] != "undefined") {
                    username = user["profile"]["lastName"];
                } else {
                    username = user["profile"]["email"];
                }
            }
        }

        jQuery(".nameAndSurname").text(username);
        jQuery(".newsletter-init").attr('href', 'javascript:showMyProfile(true);');

    } else {
        jQuery(".notlogged").removeClass('D(n)!');
        jQuery(".logged").addClass('D(n)!');
        jQuery(".nameAndSurname").text("");
    }
}

function bps4__showLogin() {
    bps4.showPasswordLess();
}

function showLogin() {
    if (getEnv() == 'dev') { console.info("showLogin"); }
    bps4__showLogin();
}

function bps4__showMyProfile() {
    bps4.showMyProfile();
}

function showMyProfile() {
    if (getEnv() == 'dev') { console.info("showMyProfile"); }
    bps4__showMyProfile();
}

function bps4__showContactUs(containerID) {
    var options = {};
    if (typeof containerID != 'undefined') {
        options.containerID = containerID;
    }
    bps4.showContactUs(options)
}

function showContactUs(containerId) {
    if (getEnv() == 'dev') { console.info("showContactUs", containerId); }
    bps4__showContactUs(containerId);
}

